import { render, staticRenderFns } from "./CustomerDiagnosticsTab.vue?vue&type=template&id=7373dbe6&scoped=true&"
import script from "./CustomerDiagnosticsTab.vue?vue&type=script&lang=js&"
export * from "./CustomerDiagnosticsTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDiagnosticsTab.vue?vue&type=style&index=0&id=7373dbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373dbe6",
  null
  
)

export default component.exports